import React from "react";

const STYLE = {
  claimed: ["Claimed", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  reminded: ["Reminded", "bg-amber-50 text-amber-800 border-amber-200"],
  invited: ["Invited", "bg-sky-50 text-sky-700 border-sky-200"],
  failed: ["Invite failed", "bg-red-50 text-red-700 border-red-200"],
  none: ["Not invited", "bg-transparent text-[#5c544b] border-dashed border-[var(--line)]"],
};

export const INVITE_FILTERS = [["", "Any invite status"], ["none", "Not invited"], ["invited", "Invited"], ["reminded", "Reminded"], ["claimed", "Claimed"], ["failed", "Invite failed"]];

export function InviteFilter({ value, onChange, id }) {
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} className={`text-xs rounded-full border px-3 py-1.5 bg-white transition-colors ${value ? "border-[var(--gold)] bg-[var(--gold)]/10" : "border-[var(--line)]"}`} aria-label="Filter by invite status" data-testid={id}>
      {INVITE_FILTERS.map(([k, l]) => <option key={k || "any"} value={k}>{l}</option>)}
    </select>
  );
}

export function inviteState(p) {
  if (!p || ["couple", "client"].includes(p.kind)) return "";
  const ci = p.claim_invite || {};
  if (p.claimed_vendor_id) return "claimed";
  if (ci.reminded_at) return "reminded";
  if (ci.sent_at) return "invited";
  if (ci.last_try_at && ci.last_ok === false) return "failed";
  return "none";
}

const when = (s) => (s ? new Date(s).toLocaleDateString([], { month: "short", day: "numeric" }) : "");

export function InviteBadge({ p, id }) {
  const st = inviteState(p);
  if (!st) return null;
  const [label, cls] = STYLE[st];
  const ci = p.claim_invite || {};
  const date = st === "reminded" ? ci.reminded_at : st === "invited" ? ci.sent_at : st === "failed" ? ci.last_try_at : "";
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[10px] uppercase tracking-wider font-medium whitespace-nowrap ${cls}`}
      title={st === "failed" ? ci.last_error || "The last invite email didn't send" : date ? `${label} ${when(date)}` : label} data-testid={`invite-badge-${id || p.prospect_id || p.pid}`} data-state={st}>
      {label}{date && st !== "failed" ? ` · ${when(date)}` : ""}
    </span>
  );
}
